<template>
  <b-container class="pt-5 text-center">
    <h1>404</h1>
  </b-container>
</template>

<script>
export default {
  name: 'Error404',
};
</script>
